<template>
<div
    id="search"
    v-bind:key="refreshKey"
    v-if="Object.keys(config).length !== 0"
  >

  <div id="header">
    <SearchForm
      :elementSlug="'default-search'"
      :offset="offset"
      :submitCallback="submitCallback"
      :resultsFiltered="resultsFiltered"
      v-on:submit-search="submitSearch"
      v-on:filter-changed="filterChanged"
      v-on:category-changed="resetResultsAndTrigger"
      v-on:reset-results="resetResults"
      v-on:reset-results-and-trigger="resetResultsAndTrigger"
      v-on:search-form-is-valid="searchFormIsValid"
    />
  </div>

  <div id="main">
    <Sidebar
      :focus="focus"
      :resultsFiltered="resultsFiltered"
      :possibleProperties="possibleProperties"
      :inSalabamInfoBox="inSalabamInfoBox"
      v-on:submit-search="submitSearch"
      v-on:filter-changed="filterChanged"
      v-on:reset-results="resetResults"
      v-on:reset-results-and-trigger="resetResultsAndTrigger"
    />

    <div id="content">

      <!-- search results -->
      <div id="search-results" ref="search-results">

          <b-row v-if="this.$route.params.propertyId">
            <b-col cols="12"><router-view></router-view></b-col>
          </b-row>

          <b-row cols="12" v-else-if="loading">
            <div id="spinner" ref="spinner">
              <Spinner />
              <p class="after-spinner">
                  Tutta la tranquillità di prenotare con {{ siteTitle }}
              </p>
            </div>
            <b-container fluid><PrefooterWhite /></b-container>
          </b-row>

          <b-row v-else-if="this.$route.params.slug !== undefined">
            <b-col cols="12"><router-view></router-view></b-col>
          </b-row>

          <!-- nessun risultato "in pancia", vari casi-->
          <b-row v-else-if="results.length == 0">
            <b-col cols="12">
              
              <div class="search-not-found">

                <svg width="700pt" height="700pt" version="1.1" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g> <path d="m428.75 201.25c-0.015625-11.73-2.668-23.305-7.7617-33.871l13.012-13.004c13.754 24.543 16.066 53.875 6.332 80.27s-30.543 47.203-56.938 56.938-55.727 7.4219-80.27-6.332l13.004-13.004c24.375 11.723 53.066 10.078 75.949-4.3438 22.883-14.426 36.734-39.605 36.672-66.652zm-204.25 162.62c21.203 37.625 45.5 74.77 68.094 107.07h-0.003906c13.094 18.766 34.531 29.945 57.41 29.945s44.316-11.18 57.41-29.945c57.625-82.301 126.34-195.89 126.34-269.68 0-39.633-12.902-78.188-36.75-109.84l-12.477 12.484v0.003907c20.621 28.27 31.73 62.359 31.727 97.352 0 72.879-77.176 193.95-123.18 259.64-9.8164 14.082-25.898 22.473-43.066 22.473s-33.25-8.3906-43.066-22.473c-25-35.457-48.207-72.145-69.527-109.93zm-17.203-32.242c-24.027-47.484-41.047-93.828-41.047-130.38-0.074219-47.723 18.449-93.594 51.645-127.88 33.195-34.285 78.441-54.289 126.14-55.762 47.699-1.4688 94.094 15.703 129.34 47.879l41.047-41.047c1.6289-1.6875 3.8711-2.6484 6.2188-2.668 2.3438-0.023437 4.6016 0.90234 6.2617 2.5625 1.6602 1.6562 2.582 3.9141 2.5625 6.2617-0.019532 2.3477-0.98438 4.5859-2.6719 6.2188l-341.25 341.25c-3.4336 3.3164-8.8906 3.2656-12.266-0.10938s-3.4219-8.832-0.10547-12.266zm191.8-191.8c-20.332-16.242-47.379-21.379-72.25-13.723-24.871 7.6602-44.34 27.125-52.012 51.992-7.668 24.867-2.5391 51.918 13.695 72.254zm-178.7 178.68 55.676-55.668c-20.754-24.797-27.66-58.367-18.375-89.348 9.2852-30.977 33.52-55.215 64.492-64.508 30.977-9.293 64.547-2.3945 89.352 18.352l49.473-49.453c-31.957-28.898-73.898-44.234-116.96-42.766-43.059 1.4688-83.859 19.621-113.78 50.629-29.918 31.004-46.602 72.426-46.531 115.51 0 32.531 15.523 74.691 36.652 117.25zm231.88 126.83c-2.3242-0.48438-4.7422 0-6.7031 1.3359-1.9609 1.3359-3.2969 3.4102-3.6992 5.75-0.40234 2.3398 0.16406 4.7422 1.5703 6.6562 1.4023 1.9141 3.5234 3.1758 5.875 3.4961 48.746 8.3555 66.93 21.305 66.93 27.43 0 12.566-55.562 35-166.25 35s-166.25-22.434-166.25-35c0-6.125 18.184-19.074 66.965-27.465 2.3516-0.32031 4.4727-1.582 5.875-3.4961 1.4062-1.9141 1.9727-4.3164 1.5703-6.6562-0.40234-2.3398-1.7383-4.4141-3.6992-5.75-1.9609-1.3359-4.3789-1.8203-6.7031-1.3359-37.188 6.3867-81.508 19.328-81.508 44.703 0 36.27 92.285 52.5 183.75 52.5s183.75-16.23 183.75-52.5c0-25.375-44.32-38.316-81.508-44.703z"/> <use x="70" y="691.25" xlink:href="#j"/> <use x="102.109375" y="691.25" xlink:href="#c"/> <use x="123.683594" y="691.25" xlink:href="#a"/> <use x="153.355469" y="691.25" xlink:href="#i"/> <use x="182.878906" y="691.25" xlink:href="#h"/> <use x="203.792969" y="691.25" xlink:href="#a"/> <use x="233.464844" y="691.25" xlink:href="#b"/> <use x="280.011719" y="691.25" xlink:href="#g"/> <use x="311.328125" y="691.25" xlink:href="#f"/> <use x="355.078125" y="691.25" xlink:href="#e"/> <use x="391.394531" y="691.25" xlink:href="#d"/> <use x="421.453125" y="691.25" xlink:href="#d"/> <use x="451.507812" y="691.25" xlink:href="#b"/> <use x="482.828125" y="691.25" xlink:href="#a"/> <use x="512.5" y="691.25" xlink:href="#c"/> </g></svg>
                
                <!-- offset == 0 => devo ancora fare la prima ricerca -->
                <p v-if="offset==0" class="after-spinner">
                  Inizia a cercare!
                </p>

                <p v-else-if="(customErrorMessage != '')" class="after-spinner">
                  <!-- nessun filtro attivo (manca check crdito disponibile)-->
                  Opsss!<br/>
                  <br/>

                  <b>{{customErrorMessage}}</b><br/>

                  <br/>
                  Per qualsiasi aiuto contatta la nostra assistenza!
                </p>

                <p v-else-if="(selectedAmenities.length == 0 && selectedCategories.length == 0)" class="after-spinner">
                  <!-- nessun filtro attivo (manca check crdito disponibile)-->
                  Oooppsss! Non abbiamo trovato risultati per la tua ricerca.<br/>
                  Prova con un'altra destinazione, un'altra data o un'altra struttura.
                </p>

                <p v-else class="after-spinner">
                  Oppsss!<br/>
                  <br/>
                  Probabilmente hai inserito troppi filtri.<br/>
                  Prova ad eliminarne qualcuno per ottenere dei risultati.<br/>
                  <br/>
                  Per qualsiasi aiuto contatta la nostra assistenza!
                </p>
              </div>
              
            </b-col>
          </b-row>

          <div v-else>
            <Results
              v-if="resultsFiltered.length > 0"
              :possibleProperties="possibleProperties"
              :geoLabel="geo.label"
              :total="resultsFiltered.length"
              :properties="resultsFiltered"
              :defaultResultsLength="defaultResultsLength"
            />

            <div v-if="offset!==-1">
              <div v-if="!appending"><!-- caso limite quando si cambia ricerca lasciando filtri impostati -->
                <div class="change-search-without-changing-filters"
                  v-if="resultsFiltered.length == 0 && results.length !== 0"
                >
                  <p>Siamo spiacenti! Non ci sono risultati per la ricerca effettuata.<br>
                  Prova a cambiare i criteri di ricerca.
                  </p>
                  <ActiveFilters />
                </div>

                <div v-else class="cta__load-more text-center">
                  <b-button v-on:click="getResults" variant="cta">Cerca altre proposte</b-button>
                </div>
              </div>
              <div v-else><Spinner /></div>
            </div>

            <div v-else>Non ci sono altri risultati per la ricerca effettuata.</div>

          </div>

      </div>

    </div>

  </div>

    <div v-if="this.$router.currentRoute.name == 'property'">
        <b-container v-if="this.$store.state.history && this.$store.state.history.properties.length > 3">
            <HistorySlider :key="this.$store.state.history.properties.length"/>
        </b-container>
    </div>

</div>
</template>

<script>
  //import Vue from 'vue'
  //import * as VueGoogleMaps from 'vue2-google-maps'
  import Api from '../../api'
  import User from '@/user'
  //import Spinner from '../atoms/spinner'
  //import SearchForm from '../blocks/search-form/search-form'
  //import Sidebar from '../blocks/sidebar/sidebar'
  //import PrefooterWhite from '../blocks/common/prefooter-white'
  //import Results from '../views/search-results'
  //import ActiveFilters from '../blocks/active-filters'
  import HistorySlider from '@/components/blocks/user/history-slider'

  export default {
    name: 'search',
    metaInfo(){
      return {
        title: (this.geo.label)? this.geo.label : 'cerca',
        meta: [
          { vmid: 'metaPrerenderStatusCode', name: 'prerender-status-code', content: '404' }
        ]
      }
    },
    components: {
      Spinner: () => import('../atoms/spinner').then(function(Spinner) {
        if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Spinner Component loaded')
        return Spinner
      }),
      SearchForm: () => import('../blocks/search-form/search-form').then(function(SearchForm) {
        if(process.env.VUE_APP_MODE != 'production') window.console.log('async: SearchForm Component loaded')
        return SearchForm
      }),
      Sidebar: () => import('../blocks/sidebar/sidebar').then(function(Sidebar) {
        if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Sidebar Component loaded')
        return Sidebar
      }),
      Results: () => import('../views/search-results').then(function(Results) {
        if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Results Component loaded')
        return Results
      }),
      PrefooterWhite: () => import('../blocks/common/prefooter-white').then(function(PrefooterWhite) {
        if(process.env.VUE_APP_MODE != 'production') window.console.log('async: PrefooterWhite Component loaded')
        return PrefooterWhite
      }),
      ActiveFilters: () => import('../blocks/active-filters').then(function(ActiveFilters) {
        if(process.env.VUE_APP_MODE != 'production') window.console.log('async: ActiveFilters Component loaded')
        return ActiveFilters
      }),
      HistorySlider,
    },
    props:{
    },
    computed: {
      occupancy: {
        get() { return this.$store.state.occupancy },
        set(value) { this.mixinSendMutation('setOccupancy',value) }
      },
      triggerSearch: {
        get() { return this.$store.state.triggerSearch },
        set(value) { this.mixinSendMutation('setTriggerSearch',value) }
      },
      dates: {
        get() { return this.$store.state.dates },
        set(value) { this.mixinSendMutation('setDates',value) }
      },
      geo: {
        get() { return this.$store.state.geo },
        set(value) { this.mixinSendMutation('setGeo',value) }
      },
      selectedAmenities: {
        get() { return this.$store.state.amenities },
        set(value) { this.mixinSendMutation('setAmenities',value) }
      },
      selectedCategories: {
        get() { return this.$store.state.categories },
        set(value) { this.mixinSendMutation('setCategories',value) }
      },
      selectedRates: {
        get() { return this.$store.state.rates },
        set(value) { this.mixinSendMutation('setRates',value) }
      },
      token: {
        get() { return this.$store.state.token },
        set(value) { this.mixinSendMutation('setToken',value) }
      },
      searchCounter: {
        get() { return this.$store.state.searchCounter },
        set(value) { this.mixinSendMutation('setSearchCounter',value) }
      },
      offsetCounter: {
        get() { return this.$store.state.offsetCounter },
        set(value) { this.mixinSendMutation('setOffsetCounter',value) }
      },
      searchLogId: {
        get() { return this.$store.state.searchLogId },
        set(value) { this.mixinSendMutation('setSearchLogId',value) }
      },
      map: {
        get() { return this.$store.state.map },
        set(value) { this.mixinSendMutation('setMap',value) }
      },
      welfareAvailability: {
        get() { return this.$store.state.welfareAvailability },
        set(value) { this.mixinSendMutation('setWelfareAvailability',value) }
      },
      availability: {
        get() { return this.$store.state.integration.availability },
        set() {}
      },
      scroll: {
        get() { return this.$store.state.scroll },
        set() {}
      },
    },
    data() {
      return {
        refreshKey: '',
        config: {},
        bands:{},
        boxsets: {},
        loading: false,
        appending: false,
        results: [],
        customErrorMessage: '',
        possibleProperties: 0,
        inSalabamInfoBox: {},
        offset: 0,
        resultsFiltered: [],
        lastSearch: '',
        focus: '',
        firstSearch: true,
        defaultResultsLength: -1,
        //maxSearch: 3,
        //searchTriggered: 0
        submitCallback: function(){
          if (
            //this.$router.currentRoute.name !== 'property' &&
            this.$router.currentRoute.name !== 'map-list'
          )
          {
            this.mixinGoTo('search',{})
          }
        },
        siteTitle: process.env.VUE_APP_SITE_TITLE,
      }
    },
    beforeCreate(){
    },
    created(){
        //this.refreshKey = window.location.href
        this.config = this.appConfig()
        if(this.triggerSearch) {
            //this.mixinGoTo('search',{})
            this.getResults()
        }
    },
    beforeMount(){
    },
    mounted() {
        /*
      Vue.use(VueGoogleMaps, {
        load: {
          key: Vue.prototype.$config.googleMapsApikey,
          libraries: 'places',
        },
        options:
        {
          strokeColor: '#6610f2'
        },
        installComponents: true
      })
      */
    },
    watch: {
      loading: function () {
        this.$nextTick(() => {
          //let spinner = this.$refs['spinner']
          if(this.loading && this.$router.currentRoute.name !== 'property')
          {
            //this.mixinSendMutation('setScroll',window.pageYOffset)
            window.scrollTo(0, 0)
          }
          else
          {
            //window.scrollTo(0, this.scroll)
          }
        })        
      }
    },
    methods: {
      submitSearch: function()
      {
        // se sono nel dettaglio e sto facendo una nuova ricerca tramite il secondo search form aggiunto, non voglio essere rediretto
        // se sono nella mappa e sto facendo una nuova ricerca tramite il punto di ricerca, non voglio essere rediretto
        /*
        if (
          this.$router.currentRoute.name !== 'property' &&
          this.$router.currentRoute.name !== 'map-list'
        )
        {
          this.mixinGoTo('search',{})
        }
        */
        this.getResults()
      },
      
      getResults: function()
      {
        let _this = this
        _this.triggerSearch = true

        let maxResults = (this.config.searchSettings.maxResults)? this.config.searchSettings.maxResults : 150

        _this.customErrorMessage = '' // eventuale messaggio di errore relativo a nessuna disponibilità, arriva da api

        if(_this.firstSearch)
        {
          _this.mixinSendMutation('setScroll', 0)
        }

        //let numberOfCalls = Math.max(_this.offsetCounter, _this.config.searchSettings.minPreviewCalls)
        //for (let index = 0; index < numberOfCalls; index++) {

          let match = {
              checkin: _this.dates.checkin,
              checkout: _this.dates.checkout,
              //nights: _this.dates.nights,
              occupancy: _this.occupancy,
              lat: _this.geo.latitude,
              lng: _this.geo.longitude,
              matchLevel: _this.geo.matchLevel,
              inSalabamId: (_this.geo.inSalabamId)? _this.geo.inSalabamId : 0,
              property_id: (_this.geo.property_id)? _this.geo.property_id : 0,
              properties_ids: (_this.geo.properties_ids)? _this.geo.properties_ids : [],
            }

          let newSearch = window.btoa(JSON.stringify(match))

          if (newSearch !== _this.lastSearch) {
            _this.offset = 0
            _this.loading = true
            _this.searchCounter = _this.searchCounter + 1
            _this.searchTriggered = 0
          }
          else
          {
            _this.appending = true
            _this.offsetCounter = _this.offsetCounter + 1

            if(_this.results.length > maxResults){
              // non permetto di "appendere" più di x strutture per questioni di ottimizzazione del loop dei filtri
              _this.loading = false
              _this.offset = -1
              _this.appending = false
              return
            }
          }

          if(_this.offset == -1)
          {
            _this.loading = false
            _this.appending = false
            return
          }

          let parameters = {
              checkin: _this.dates.checkin,
              checkout: _this.dates.checkout,
              //nights: _this.dates.nights,
              occupancy: _this.occupancy,
              lat: _this.geo.latitude,
              lng: _this.geo.longitude,
              offset: _this.offset,
              matchLevel: _this.geo.matchLevel,
              label: _this.geo.label,
              searchCounter: _this.searchCounter,
              debugString: _this.debugString,
              salabamCategories: _this.selectedCategories,
              inSalabamId: (_this.geo.inSalabamId)? _this.geo.inSalabamId : 0,
              property_id: (_this.geo.property_id)? _this.geo.property_id : 0,
              properties_ids: (_this.geo.properties_ids)? _this.geo.properties_ids : [],
            }

          _this.lastSearch = newSearch

          _this.getPreview(parameters, 'default')//'default', 'nearby

      },

      getPreview(parameters, mode)
      {
        Api
          .getPreview(parameters)
          .then((preview) => {

            let _this = this,
                needsNearBySearch = false, //flag che attiva la chiamata nearby in background se ci sono pochi risultati in almeno un cofanetto
                searchSuggestionMinResults = _this.config.searchSettings.searchSuggestionMinResults

            this.inSalabamInfoBox = preview.inSalabamInfoBox

            if(preview == false) // http status !== 200 vedi api.js
            {
              if(_this.offset == 0)
              {
                _this.results = {}
                _this.possibleProperties = 0
                _this.resultsFiltered = {}
                _this.map.data = {}
                _this.appending = false
              }
              _this.loading = false
              return
            }

            // andrebbero messe in append e resettate al cambio ricerca
            // altrimenti in caso di "carica altri risultati" ho solo le chiavi dell'ultima chiamata
            if(preview.cks) this.mixinSendMutation('setCacheKeys', preview.cks)


            _this.customErrorMessage = (preview.customErrorMessage)? preview.customErrorMessage : ''


            let results = preview.results

            if(!results){
              _this.loading = false
              _this.appending = false
              return
            }

            results.forEach(property => {
                property.lite = User.getLiteProperty(property, 'preview')
            })

            //manipolo a monte l'ordine per spostare in alto i primi tre con live_price <= availability
            if(_this.availability > 0 && _this.config.searchSettings.purchasableResultsToPutOnTop !== 0 )
            {
              let availableRateIds = [],
                  availableRateHotels = []

              preview.results.some(function(hotel) {
                if(hotel.live_price <= _this.availability)
                {
                  availableRateIds.push(hotel.rate_id)
                  availableRateHotels.push(hotel)
                }
                return availableRateIds.length == _this.config.searchSettings.purchasableResultsToPutOnTop
              })

              availableRateHotels = availableRateHotels.sort(function(a, b) {
                return a.live_price <= b.live_price;
              })

              let resultsFilteredOrdered = preview.results.filter(function(hotel) {
                return (!availableRateIds.includes(hotel.rate_id))
              })

              results = availableRateHotels.concat(resultsFilteredOrdered)

              for (let index = 0; index < results.length; index++) {
                results[index].defaultSorting = (index+1)
              }
            }
            //fine ordinamento dei primi tre con live_price <= availability


            let resultsFilteredTemp = _this.getResultsFiltered(preview.results)

            if(_this.offset == 0)
            {

              // mode == 'default': gestione ricerca di default, nessun cambiamento
              if(mode == 'default')
              {
                _this.results = results //preview.results
                _this.possibleProperties = (preview.counts) ? preview.counts.possibleProperties : 0
                _this.resultsFiltered = _this.getResultsFiltered(_this.results)



                if(preview.geography)
                {
                  // se inSalabam non ritorna geography

                  // preview.geography può essere rimandata alle api
                  // essendoci coordinate decimali, nel rimbalzo qualcosa le incasina
                  // scambiandomele codificate inn b64 risolvo il problema
                  if(typeof(preview.geography) == 'string')
                  {

                    let tempGeography = JSON.parse(atob(preview.geography))
                    if(tempGeography) _this.map.geography = tempGeography

                  }
                  else
                  {

                    _this.map.geography = preview.geography // retrocompatibilità, aggiorno prima clients poi api

                  }

                }else{
                  _this.map.geography = {}
                } // if preview.geography



                if(_this.$gtm){

                  _this.$gtm.trackEvent({
                    event: 'customEvent',
                    category: 'search',
                    action: 'firstSearchResults',
                    label: preview.geoLabel,
                    value: _this.results.length,
                  });

                  _this.$gtm.trackEvent({
                    event: 'customEvent',
                    category: 'search',
                    action: 'matchLevel',
                    label: _this.geo.matchLevel,
                    value: _this.geo.label,
                  });

                }


              }

              // se sono in 'default' devo solo valutare se serve un'altra chiamata con 'nearby', se sono in nearby devo solo appendere i nuovi risultati
              // caso offset=0 e mode='default': se ci sono pochi risultati metto a true il flag che pilota la chiamata (nearby) in background
              if(mode == 'default') //ignoro eventuali chiamate con 0 risultati
              {

                // alcuni matchLevel non devono triggerare nearby
                let matchLevelsNoNeedsNearBySearch = ['inSalabam', 'property', 'properties', 'favorites', 'history'];

                needsNearBySearch = (   _this.results.length < searchSuggestionMinResults
                                     && preview.matchLevel
                                     && matchLevelsNoNeedsNearBySearch.indexOf(preview.matchLevel) === -1)

                // valorizzo solamente se serve nearBy altrimenti mostrerà la pad nearBy anche quando si clicca "carica altri risultati"
                _this.defaultResultsLength = (needsNearBySearch)? _this.results.length : -2 // -1 già usato come flag

              }

              // caso offset=0 e mode='nearby': appendo i risultati se ho pochi risultati
              if(mode == 'nearby')
              {
                if(_this.results.length < searchSuggestionMinResults)
                {
                  _this.results = _this.results.concat(preview.results)
                  _this.resultsFiltered = _this.resultsFiltered.concat(resultsFilteredTemp)
                }
              }

            }
            else // caso offset > 0, quindi chiamata 'default' per forza
            {
              let resultsFilteredTemp = _this.getResultsFiltered(results)
              _this.results = _this.results.concat(results)
              _this.resultsFiltered = _this.resultsFiltered.concat(resultsFilteredTemp)
            }

            _this.map.data = _this.resultsFiltered
            _this.searchLogId = preview.searchLogId

            // non serve aggiornare offset, focus e banda nel caso 'nearby', è già stato fatto alla chiamata 'default'
            if(mode == 'default')
            {

              // faccio in modo che i redirects alla mappa avvengano solo alla prima ricerca
              // (e non anche quando si clicca su carica altri risultati)
              if(_this.offset > 0) _this.geo.ignoreMapRedirect = true;


              _this.offset = preview.offset
              //_this.lastSearch = newSearch // questo era replicato, viene gestito a monte in getResults
            

              // ignoreMapRedirect viene usato per gestire le navigazioni "direttamente alla pagina dettaglio" - https://trello.com/c/7oWYmzkB/855-invadobay-slider-monografico
              if ( _this.results.length > 0 && (_this.geo.matchLevel == 'point' || _this.geo.matchLevel == 'inSalabam') && !_this.geo.ignoreMapRedirect)
              {
                _this.mixinGoTo('map-list', {
                  slug: (_this.geo.label).replace(/ /g, '-'),
                  title: _this.geo.label,
                  propertyId: 0
                })
              }

              // qui finiva la ricerca normale
              // ora decido se fare o meno la chiamata nearby in background
              // window.console.log('needsNearBySearch '+needsNearBySearch)
              if(needsNearBySearch)
              {

                parameters.matchLevel = 'nearby'

                // per ricerca nearby rimbalzo la geography usata nella prima ricerca
                // così che poi possa usare un poligono più grande e per "differenza" non includere
                // poligoni/risultati già selezionati
                if(preview.geography) parameters.geography = preview.geography

                _this.getPreview(parameters, 'nearby')

              }
              else
              {
                // a prescindere dal caso loading vs appending, se non serve una chiamata nearby allora il percorso di ricerca è finito e vanno messi a false entrambi
                _this.loading = false
                _this.appending = false
              }

            }

            // a prescindere dal caso loading vs appending, in nessun caso al termine della chiamata 'nearby' i flag loading,appending possono restare true
            if(mode == 'nearby')
            {
              _this.loading = false
              _this.appending = false
            }


            if(_this.geo.matchLevel == 'property' && _this.results.length == 1){
              // ricerca struttura per nome o property_id, salto direttamente al dettaglio

              this.mixinSendMutation('setPropertyDetail', _this.results[0])
              this.mixinGoTo('property',{
                propertyId: _this.results[0].property_id,
                propertyPad: _this.results[0],
                propertyName: _this.results[0].name,
                newWindow: false
              })

            }


          }) // then

      }, // getPreview

      getResultsFiltered(results){
        /* live booking */
        let resultsFiltered = [],
            availability = parseFloat(this.availability)

        if(this.welfareAvailability)
        {
          results = results.filter(function (el) {
            return el.live_price <= availability
          })          
        }

        for(let room in results)
        {
          //for(let room in results[property])
          //{
            //window.console.log(this.selectedRates)
            if( this.selectedCategories.length == 0 | this.selectedCategories.includes(results[room].salabamCategory) )
            {
              let rateOk = false
              if(this.selectedRates.length == 0)
              {
                rateOk = true
              }
              else
              {
                for (let r = 0; r<this.selectedRates.length; r++)
                {
                  if( this.selectedRates[r] <= results[room].hotelRating && results[room].hotelRating < this.selectedRates[r]+1)
                  {
                    rateOk = true
                    break
                  }
                }
                //return
              }
              let roomOk = true
              for (let f = 0; f < this.selectedAmenities.length; f++) {
                if (!(this.selectedAmenities[f] in results[room].amenities))
                {
                  roomOk = false
                  break
                }
              }
              if(roomOk && rateOk) resultsFiltered.push(results[room])
            }
          //}
        }
        return resultsFiltered
        /* live booking */
      },

      filterChanged()
      {
        if(this.results == undefined) {return}
        if(this.results.length == 0) {return}
        //if(this.results)
        {
          let _this = this
          _this.loading = true
          _this.mixinSendMutation('setScroll', 0)
          setTimeout(function(){
            _this.resultsFiltered = _this.getResultsFiltered(_this.results)
            _this.map.data = _this.resultsFiltered
            _this.loading = false
          },50)
        }
      },

      searchFormIsValid()
      {
        if(this.firstSearch & !this.triggerSearch)
        {
          this.firstSearch = false
          this.getResults()
        }
      },

      resetResultsAndTrigger()
      {
          window.console.log('reset-results-and-trigger')
        let _this = this
        _this.loading = true
        _this.offset = 0
        setTimeout(function(){
          _this.results = []
          _this.resultsFiltered = []
          _this.offset = 0
          _this.getResults()
        },50)
      },

      resetResults()
      {
        let _this = this
        _this.loading = true
        
        setTimeout(function(){
          _this.results = []
          _this.resultsFiltered = []
          _this.offset = 0
          //_this.loading = false
        },50)
      }

    },
    beforeDestroy: function () {
        window.console.log('[search] beforeDestroy')
    },
    destroyed () {
        window.console.log('[search] destroyed')
    },    
  }
</script>

<style lang="scss">
    
    #search {
        @include media-breakpoint-up(lg)
        {
            padding-top:$page-header-desktop-height;
            //margin-top:80px;
            #header
            {
                display: flex;
                justify-content: flex-end;
                margin-top:30px;
                margin-bottom:20px;
                padding-top:0;
                
                @include media-breakpoint-up(xl)
                {
                    margin-top: 0;
                    margin-bottom: 0;
                }

                #search-form
                {
                    width:100%;
                    background-color:transparent;

                    @include media-breakpoint-up(xl)
                    {
                        width:80%;
                    }
                }
                .search-form-fields
                {
                    padding-right: 0;
                }
            }
        }

        #search-results > div > .card {
        border:0;
        background:transparent;
        .card-header
        {
            display:none !important;
        }
        .card
        {
            border:0;
            border-radius:0;
            background:transparent;
        }
        .card-body
        {
            padding:0;
        }
        }
        
        .map-link {
        position:relative;
        span
        {
            position:absolute;
            width:100%;
            left:0;
            right:0;
            bottom:0;
            background:$white;
            box-shadow: $box-shadow;
            @include customize-color("secondary");
            font-weight:bold;
            font-size:14px;
            white-space:nowrap;
            text-align:center;
            padding:4px 6px;
            border-radius: $border-radius/2;
        }
        }
    }

    #header
    {
    position:fixed;
    z-index: 10;
    left:0;
    right:0;
    top:$page-header-mobile-height;
    
    margin-left:$grid-gutter-width/2;
    margin-right:$grid-gutter-width/2;

    #search-form
    {
        display:flex;
        flex-direction: column;
        align-items: center;
    }
    #before-header
    {
        order:2;
    }
    .form-content-mobile
    {
        order:1;
        .search-form-fields,
        .search-form-filters
        {
        overflow-y:scroll;
        overflow-x:hidden;
        height:calc(100vh - #{$mobile-header-height} - 110px);
        }
    }
    @include media-breakpoint-up(lg)
    {
        top:0;
        #search-form
        {
        display:block;
        }
        height:auto;
        position:relative;
        padding:1rem 0;
        margin-left:$grid-gutter-width;
        margin-right:$grid-gutter-width;

    }
    @include media-breakpoint-up(xl)
    {
        padding:2rem 0;
    }
    }

    .change-search-without-changing-filters
    {
        margin-top:1.25rem;
        .geo
        {
        display:none;
        }
    }

    #search-results .prefooter-blocks-large
    {
        .block-wrap
        {
        @include media-breakpoint-up(xl)
        {
            max-width: 50% !important;
            width: 50% !important;
            flex: 50%;
        }
        }
    }

    #spinner
    {
        width:100%;
        text-align: center;
    }

    @include media-breakpoint-down(md)
    {
      #main {
        display:flex;
        flex-direction: column;
      }
      #sidebar {
          
          margin-bottom: 20px;

          @at-root .page-search & {
            border-bottom: 1px solid $gray-400;
          }

          @at-root .page-property & {
            order: 2;
          }
        }
    }

    #search-form .form-content-mobile
    {
        #toggle-search-settings
        {
            padding-left: 0;
            margin-left:1rem;
            width:40px;
            display:flex;
            align-items: center;
            justify-content: center;
        }
        .open-search-settings
        {
            display:block;
        }
        .close-search-settings
        {
            display:none;
            span
            {
                display:block;
                height:2px;
                width:24px;
                background-color:$smooth-black;
                &:first-child
                {
                    transform:rotate(45deg) translateY(20px) translateX(12px);
                }
                &:last-child
                {
                    transform:rotate(-45deg) translateY(10px) translateX(-19px);
                }
            }
        }        
    }

    .search-not-found {
      text-align: center;
      margin-top: 100px;
      
      svg {
        width: 150px;
        height: 150px;
        opacity: .20;
      }
      
      .after-spinner {
        opacity: .70;
        font-size: 19px;
        text-shadow: 1px 1px 1px #fff;
        font-weight: 600;
      }
    }

    .mobile-filter-on #search-form
    {
        //border:10px solid red;
        .form-content-mobile
        {
            .search-form-filters
            {
                background:$light-gray;
                width:100vw;
                margin-left:-30px;
                padding:0 30px;;
            } 
            
            #toggle-search-settings
            {
                .open-search-settings
                {
                    //display:none;
                }
                .close-search-settings
                {
                    //display:block;
                }
            }
        }
    }

    .mobile-search-on
    {
        #header
        {
            background:$light-gray;
            width:100vw;
            margin-left:0;
            margin-right:0;
            padding:0 30px;;
        }
        #search-form
        {
            //border-radius: 0;
        }
        .search-form-fields
        {
        }
    }
</style>